import React from 'react';

export const CALC_SEPARATOR = '. Calculation: ';

export const renderTooltipContent = (tooltip: string): React.ReactNode => {
    const idx = tooltip.indexOf(CALC_SEPARATOR);
    if (idx === -1) return tooltip;
    const definition = tooltip.substring(0, idx);
    const calculation = tooltip.substring(idx + CALC_SEPARATOR.length);
    return (
        <div>
            <div>
                <span className="tooltipLabel">Definition: </span>
                {definition}
            </div>
            <br />
            <div>
                <span className="tooltipLabel">Calculation: </span>
                {calculation}
            </div>
        </div>
    );
};
